export default __webpack_public_path__ + "static/media/smartApyUpdatedGraphivs.eca60084.png";